import { FolderKanban, AlertTriangle } from "lucide-react";
import { useWorkspace } from "../../context/WorkspaceContext";

/** Shows the current global Project context on pages that no longer own a Project selector.
 *  When `requireProject` is set and context is All Projects, prompts the user to pick one. */
export function ProjectScopeBanner({ requireProject = false, action = "this action" }) {
  const { ctx } = useWorkspace();
  const p = ctx.project;

  if (requireProject && !p) {
    return (
      <div data-testid="scope-require-project" className="mb-4 flex items-center gap-2 rounded-lg border border-amber-300 bg-amber-50 px-4 py-2.5 text-sm text-amber-800">
        <AlertTriangle className="h-4 w-4 shrink-0" />
        Select a specific <span className="font-semibold">Project</span> from the top bar to perform {action}.
      </div>
    );
  }
  return (
    <div data-testid="project-scope-banner" className="mb-4 inline-flex items-center gap-2 rounded-md border border-blue-200 bg-blue-50 px-3 py-1.5 text-sm">
      <FolderKanban className="h-3.5 w-3.5 text-blue-600" />
      <span className="text-xs text-slate-500">Viewing:</span>
      <span className="font-semibold text-blue-800">{p ? `${p.project_code ? p.project_code + " — " : ""}${p.project_name}` : "All Projects"}</span>
    </div>
  );
}
